var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33594 0.905273C8.60613 0.365223 9.39387 0.365223 9.66406 0.905273L11.7734 5.12012L11.8906 5.35449L12.1494 5.3916L16.8672 6.06641C17.4805 6.15414 17.706 6.88361 17.2773 7.2959L13.8643 10.5762L13.6729 10.7607L13.7178 11.0225L14.5234 15.6543C14.6233 16.2295 14.005 16.7009 13.4492 16.4131H13.4482L9.23047 14.2266L9.00098 14.1074L8.77051 14.2266L4.55176 16.4131C3.99579 16.7014 3.37672 16.2295 3.47656 15.6543L4.28223 11.0225L4.32715 10.7607L4.13574 10.5762L0.722656 7.2959L0.72168 7.29492C0.29472 6.88438 0.519239 6.15497 1.13379 6.06641L1.13281 6.06543L5.85059 5.3916L6.10938 5.35449L6.22656 5.12012L8.33594 0.905273Z",
    stroke: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite-icon.b6589ea9363ac5c86e4942813fb1bfd9.svg";
export { ForwardRef as ReactComponent };